import React from 'react';
import { Cookies } from 'react-cookie';

const PREFERRED_LANGUAGE_COOKIE = 'preferred_language';

interface LocaleState {
  language: 'en' | 'it';
  showingMultiLocaleContent: boolean;
}

export interface LocaleValues extends LocaleState {
  setShowingMultiLocaleContent: (showingMultiLocaleContent: boolean) => void;
  setLanguage(language: 'en' | 'it'): void;
}

export class Locale extends React.Component<{ cookies: Cookies }, LocaleState> {
  state: LocaleState = {
    language: 'en',
    showingMultiLocaleContent: false,
  };

  componentDidMount() {
    this.setState({ language: this.getPreferredLanguage() });
  }

  getPreferredLanguage() {
    const cookieValue = this.props.cookies.get(PREFERRED_LANGUAGE_COOKIE);
    if (cookieValue === 'en' || cookieValue === 'it') {
      return cookieValue;
    }
    return this.userAcceptsLanguage('it') ? 'it' : 'en';
  }

  userAcceptsLanguage(language: string) {
    const acceptedLanguages =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language ?? 'en'];
    return acceptedLanguages
      .map((acceptedLanguage) => acceptedLanguage.replace(/-.+$/, '').toLowerCase())
      .includes(language);
  }

  render() {
    return (
      <LocaleContext.Provider
        value={{
          ...this.state,
          setShowingMultiLocaleContent: (showingMultiLocaleContent: boolean) => {
            this.setState({ showingMultiLocaleContent: showingMultiLocaleContent });
          },
          setLanguage: (language: 'en' | 'it') => {
            this.props.cookies.set(PREFERRED_LANGUAGE_COOKIE, language);
            this.setState({ language });
          },
        }}
      >
        {this.props.children}
      </LocaleContext.Provider>
    );
  }
}

export class Localized extends React.Component<{ content: (locale: LocaleValues) => JSX.Element }> {
  render() {
    return (
      <LocaleContext.Consumer>
        {(locale) => (
          <LocalizedInner setShowingMultiLocaleContent={locale.setShowingMultiLocaleContent}>
            {this.props.content(locale)}
          </LocalizedInner>
        )}
      </LocaleContext.Consumer>
    );
  }
}

class LocalizedInner extends React.Component<{
  setShowingMultiLocaleContent: (showingMultiLocaleContent: boolean) => void;
}> {
  componentDidMount() {
    this.props.setShowingMultiLocaleContent(true);
  }

  componentWillUnmount() {
    this.props.setShowingMultiLocaleContent(false);
  }

  render() {
    return this.props.children;
  }
}

export const LocaleContext = React.createContext<LocaleValues>(/* default= */ undefined);
